const Item_Types = Object.freeze({
  TOP_UP: 'Top-up',
  LOCAL_CALLS: 'Local calls',
  ITERNATIONAL_CALLS: 'International calls',
  ADDONS: 'Add-ons',
});

export { Item_Types }; // eslint-disable-line import/prefer-default-export
